export default __webpack_public_path__ + "b9148eb34c6df2e5e68400f8f851d66d.png";